module.exports = __webpack_public_path__ + "static/media/image1.cfd71e16.jpg";